var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.625 2.125C24.5531 2.125 25.3125 2.853 25.3125 3.75L25.3125 23.25C25.3125 24.147 24.5531 24.875 23.625 24.875L3.375 24.875C2.4435 24.875 1.6875 24.147 1.6875 23.25L1.6875 3.75C1.6875 2.853 2.4435 2.125 3.375 2.125L23.625 2.125ZM0 3.75L0 23.25C0 25.0448 1.51116 26.5 3.375 26.5L23.625 26.5C25.4897 26.5 27 25.0448 27 23.25L27 3.75C27 1.95519 25.4897 0.5 23.625 0.5L3.375 0.5C1.51116 0.5 0 1.95519 0 3.75ZM7.14237 12.7858C6.93987 12.9808 6.87658 13.2473 6.92298 13.5C6.87658 13.7527 6.93987 14.0192 7.14237 14.2142L11.9146 18.8097C12.2445 19.1274 12.7794 19.1274 13.1076 18.8097C13.4375 18.4936 13.4375 17.9785 13.1076 17.6608L9.63056 14.3125L18.5625 14.3125C19.0266 14.3125 19.4063 13.9493 19.4063 13.5C19.4063 13.0515 19.0266 12.6875 18.5625 12.6875L9.63056 12.6875L13.1076 9.33921C13.4375 9.02152 13.4375 8.50721 13.1076 8.19033C12.7794 7.87265 12.2445 7.87265 11.9146 8.19033L7.14237 12.7858Z",
    fill: "#003644",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledArrowLeft);
export default __webpack_public_path__ + "static/media/DisabledArrowLeft.4470b618673826d8d4c8baf0227be636.svg";
export { ForwardRef as ReactComponent };